import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0, 2, 2, 2),
    width: "100%",
    minHeight: "calc(100vh - 80px)",
  },
  pageName: {
    paddingTop: theme.spacing(3),
    font: "var(--unnamed-font-style-normal) normal bold 30px/34px var(--unnamed-font-family-arial)",
    letterSpacing: "var(--unnamed-character-spacing-0)",
    color: "var(--unnamed-color-ffffff)",
    opacity: 1,
  },
  table: {
    minWidth: 700,
  },
  blockedRow: {
    backgroundColor: "#fac0d55e",
    "& td": {
      backgroundColor: "#fde7efbd",
    },
    "&:hover td": {
      backgroundColor: "#f9d7e3 !important",
    },
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
  },
  card: {
    border: "1px solid #092147",
    borderRadius: "5px",
    width: "100% !important",
    padding: "1em",
    marginTop: "1em",
  },
  iconRed: {
    color: "red!important",
  },
}))
export default useStyles
